import React, { useState } from 'react';
import '../Chat.css';

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim()) {
      const newMessage = {
        text: inputValue,
        sender: 'user',
        timestamp: new Date().toLocaleString(),
        read: false,
      };
      setMessages([...messages, newMessage]);
      setInputValue('');
      // ここでボットの応答を模擬する
      setTimeout(() => {
        const botMessage = {
          text: 'ボットからの応答',
          sender: 'bot',
          timestamp: new Date().toLocaleString(),
          read: true,
        };
        setMessages((prevMessages) => [...prevMessages, botMessage]);
      }, 1000);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-window">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`message ${message.sender === 'user' ? 'user' : 'bot'}`}
          >
            <div className="message-header">
              <img
                src={message.sender === 'user' ? "user" : "bot"}
                alt={message.sender}
                className="avatar"
              />
              <span className="timestamp">{message.timestamp}</span>
              {message.sender === 'bot' && message.read && (
                <span className="read-status">既読</span>
              )}
            </div>
            <div className="message-text">{message.text}</div>
          </div>
        ))}
      </div>
      <form onSubmit={handleSubmit} className="chat-input">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="メッセージを入力してください"
          className="input-field"
        />
        <button type="submit" className="send-button">
          送信
        </button>
      </form>
    </div>
  );
};

export default Chat;